<template>
    <div>
        <b-modal
            :visible="value"
            :id="modal_id"
            size="lg"
            @cancel="cancel"
            @close="cancel"
            @hidden="hidden"
        >
            <template #modal-title>
                Add Interactive Media Link
            </template>

            <b-tabs content-class="my-3">
                <b-tab title="Printables" active>
                    <Worksheets
                        :article="article"
                        :panel="panel"
                        @add="addInteractiveMediaLink"
                    />
                </b-tab>
                <b-tab title="Related Media">
                    <related-media
                        :article="article"
                        :publication_id="publication_id"
                        :panel="panel"
                        @add="addInteractiveMediaLink"
                    />
                </b-tab>
            </b-tabs>

            <template #modal-footer>
                <b-button
                    variant="light"
                    @click="cancel"
                >
                    Cancel
                </b-button>
            </template>
        </b-modal>
    </div>
</template>

<script>
import {mapState} from 'vuex'
import Worksheets from '@/components/modals/article/interactive_media_link/Worksheets'
import RelatedMedia from '@/components/modals/article/interactive_media_link/RelatedMedia'

export default {
    data: () => ({}),
    props: [
        'value',
        'article',
        'publication_id',
        'panel',
    ],
    components: {
        Worksheets,
        RelatedMedia
    },
    computed: {
        ...mapState({
            articles: state => state.unit.articles
        }),
        modal_id() {
            let modal_id = 'interactive-media-link-modal'

            return modal_id
        }
    },
    methods: {
        addInteractiveMediaLink(item, type) {
            this.$emit('add', item, type)
        },
        cancel(event) {
            event.preventDefault()

            this.hide()
        },
        hide() {
            this.$emit('hide')
        },
        hidden() {
            this.$emit('hide')
        }
    }
}
</script>
